/* S1 Trust Stats: fade-ins only (static content). */

class S1TrustStats extends HTMLElement {
  connectedCallback() {
    if (!this._fadeIo) {
      this._fadeIo = new IntersectionObserver((entries) => {
        entries.forEach((en) => {
          if (en.isIntersecting) {
            en.target.classList.add('is-visible');
            this._fadeIo.unobserve(en.target);
          }
        });
      }, { threshold: 0.2 });
    }
    this.querySelectorAll('.s1-ts-fade:not(.is-visible)').forEach((el) => this._fadeIo.observe(el));
  }

  disconnectedCallback() {
    if (this._fadeIo) this._fadeIo.disconnect();
  }
}

if (!customElements.get('s1-trust-stats')) {
  customElements.define('s1-trust-stats', S1TrustStats);
}
